import { orderBy } from 'lodash';

type NamedItem = {
    name?: string | null;
};

export const sortAvatarItemsByName = <T extends NamedItem>(items: T[]): T[] => (
    orderBy(items, item => (item.name ?? '').trim().toLowerCase(), 'asc')
);

export const getEmployeeNames = <T extends NamedItem>(items: T[]): string => (
    sortAvatarItemsByName(items)
        .map(item => item.name ?? '')
        .join(' ')
);
